import ShopLocalizationsPage from './ShopLocalizationsPage';
export default ShopLocalizationsPage;
